import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { DeviceUpdateEvidenceFieldSectionPayload } from 'api/actions/device-update-evidence-field-section/device-update-evidence-field-section-payload';
import { DeviceUpdateEvidenceFieldSectionPathParameters } from 'api/actions/device-update-evidence-field-section/device-update-evidence-field-section-path-parameters';
import { DeviceUpdateEvidenceFieldSectionResponse } from 'api/actions/device-update-evidence-field-section/device-update-evidence-field-section-response';

type DeviceUpdateEvidenceFieldSectionQueryParameters = Record<string, any>;

/**
 * The path of the DeviceUpdateEvidenceFieldSection action.
 */
export const deviceUpdateEvidenceFieldSectionActionPath = new SweetPath<
  keyof DeviceUpdateEvidenceFieldSectionPathParameters
>('/api/device/evidence-field-sections/update/{sectionId}', { path: '{param}' });

/**
 * Creates a contextualized DeviceUpdateEvidenceFieldSection actions.
 */
export default function createDeviceUpdateEvidenceFieldSectionAction(axios: AxiosInstance) {
  return function deviceUpdateEvidenceFieldSectionAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: DeviceUpdateEvidenceFieldSectionPathParameters;
    query?: DeviceUpdateEvidenceFieldSectionQueryParameters;
    payload: DeviceUpdateEvidenceFieldSectionPayload;
  }) {
    const path = deviceUpdateEvidenceFieldSectionActionPath.insert(parameters);

    return axios.request<DeviceUpdateEvidenceFieldSectionResponse, DeviceUpdateEvidenceFieldSectionResponse>({
      method: 'put',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
